import {
  PrescriptionForm,
  PrescriptionFormControllerApi,
} from "../../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

interface Params {
  prescriptionForm: PrescriptionForm;
  xTENANTID?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useUpdateOrderPrescription = () =>
  useMutationWithLoading(async (params: Params) =>
    new PrescriptionFormControllerApi(getConfigObject()).updatePrescriptionForm(
      params?.prescriptionForm,
      params?.xTENANTID
    )
  );
